import React from 'react';

// Field select over catalog/result fields ({ key, label, fullLabel }),
// rendered as a labeled form control so it matches the rest of the app
// (.form-field / .form-label / .form-select) and is announced to screen
// readers instead of being an unlabeled combobox.
export default function FieldSelect({
  options,
  value,
  onChange,
  label,
  placeholder = '—',
  multiple
}) {
  const id = label ? `field-select-${label.toLowerCase().replace(/[^a-z0-9]+/g, '-')}` : undefined;
  return (
    <div className="form-field">
      {label && (
        <label className="form-label" htmlFor={id}>
          {label}
        </label>
      )}
      <select
        id={id}
        className="form-select"
        value={multiple ? value || [] : value || ''}
        onChange={(e) =>
          onChange(multiple ? Array.from(e.target.selectedOptions, (o) => o.value) : e.target.value)
        }
        multiple={multiple}
        size={multiple ? 4 : undefined}
      >
        {(options || []).map((f) => (
          <option key={f.key} value={f.key}>
            {f.fullLabel || f.label || f.key}
          </option>
        ))}
      </select>
      {multiple && <span className="form-hint">Hold Ctrl/Cmd to select multiple</span>}
    </div>
  );
}
